import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, SortEvent } from 'primeng/api';

import { ActivatedRoute, Router } from '@angular/router';
import { PessoaService } from '../../../../../../services/pessoas/pessoas.service';
import { NotaService } from '../../../../../../services/financeiro/notas.service';
import { NotaDTO } from '../../../../../../models/nota.model';

@Component({
  selector: 'app-clientes-table',
  templateUrl: './clientes-table.component.html',
  styleUrls: ['./clientes-table.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class ClientesTableComponent implements OnInit {
  @Input() clienteID: number | undefined;
  products: any[] = [];
  notas: NotaDTO[] = [] as NotaDTO[];
  first = 0;
  rows = 5;
  totalRecords = 0;
  lastfield = 'id';
  lastSort = 'asc';
  searchCodigo: string = '';
  rangeDates: any[] = [];
  options = [
    { label: 5, value: 5 },
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 120, value: 120 },
  ];

  constructor(private router: Router, private notaService: NotaService) {}

  async ngOnInit() {
    if (!this.clienteID) {
      return;
    }
    await this.findNota(0, this.rows, 'id,asc');
  }

  findNota(
    page: number = 0,
    size: number = this.rows,
    sort: string = 'id,asc'
  ): Promise<void> {
    return new Promise((resolve) => {
      const codigoMovimento = this.searchCodigo
        ? `&codigoNota=${this.searchCodigo}`
        : '';
      const dataInicio =
        this.rangeDates.length > 0
          ? `&dataInicio=${this.formatDate(this.rangeDates[0])}`
          : '';
      const dataFim =
        this.rangeDates.length > 0
          ? `&dataFim=${this.formatDate(this.rangeDates[1])}`
          : '';

      const filter =
        `pessoaId=${this.clienteID}` +
        (codigoMovimento ? `${codigoMovimento}` : '') +
        (dataInicio ? `${dataInicio}` : '') +
        (dataFim ? `${dataFim}` : '');

      this.notaService
        .get('/nota/buscar', { page, size, sort, filter })
        .subscribe(
          (response) => {
            this.notas = response.content;
            this.totalRecords = response.totalElements; // Atualiza o total de registros
            this.first = page * size;
            resolve();
          },
          (error) => {
            console.error('Erro ao buscar clientes:', error);
            this.notas = [];
            this.totalRecords = 0;
            this.rangeDates = [];
          }
        );
    });
  }

  onPageChange(event: any) {
    const page = event.page; // Página atual a partir do paginator
    const size = event.rows; // Quantidade de itens por página
    this.findNota(page, size);
  }

  onRowsPerPageChange() {
    this.first = 0; // Reiniciar a página para o início
    this.findNota(0, this.rows); // Buscar a primeira página com o novo tamanho
  }

  customSort(event: SortEvent) {
    let sort = 'desc';
    if (event.order === 1) {
      sort = 'asc';
    } // 1 é ascendente, -1 é descendente}

    if (this.lastfield === event.field && this.lastSort === sort) {
      return;
    } // Essencial para não cair em loop infinito

    this.lastfield = String(event.field);
    this.lastSort = String(sort);

    this.findNota(0, this.rows, `${event.field},${sort}`);
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  search() {
    this.findNota(0, this.rows, `${this.lastfield},${this.lastSort}`);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Preenche com zero à esquerda
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam em 0
    const year = String(date.getFullYear()).slice(-4); // Pega os últimos 2 dígitos do ano
    return `${day}/${month}/${year}`;
  }
}
